export default __webpack_public_path__ + "assets/images/588dd6535941048ed47facd78875be6d.png";